import React from 'react';
import { Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

import HotelCardSkeleton from '../SharedHotelCardContent/HotelCardSkeleton';

const HotelsResultsContainerSkeleton = ({ isMobile, viewFullWidhtMap }) => {
  const skeletonCount = 6;

  return (
    <Grid
      container
      rowSpacing={0}
      columnSpacing={3}
      sx={{ p: 3 }}
      id="GRIDCONTAINERHOTELCARDS-SKELETON"
    >
      {/* 🗺️ Map Skeleton */}
      <Grid
        item
        xs={12}
        sm={viewFullWidhtMap ? 12 : 6}
        md={viewFullWidhtMap ? 12 : 5}
        lg={viewFullWidhtMap ? 12 : 4}
        xl={viewFullWidhtMap ? 12 : 4}
        id="GRIDCONTAINERMAP-SKELETON"
        sx={{
          position: { xs: 'static', md: 'sticky' },
          top: { xs: 'auto', md: 0 },
          alignSelf: { xs: 'auto', md: 'flex-start' },
          maxHeight: { xs: 'none', md: '100vh' },
        }}
      >
        <Skeleton
          variant="rectangular"
          width="100%"
          height={isMobile ? 320 : '100vh'}
        />
      </Grid>

      {/* 🏨 List Skeleton */}
      <Grid
        item
        xs={12}
        sm={viewFullWidhtMap ? 12 : 6}
        md={viewFullWidhtMap ? 12 : 7}
        lg={viewFullWidhtMap ? 12 : 8}
        xl={viewFullWidhtMap ? 12 : 8}
        id="GRIDCONTAINERLIST-SKELETON"
      >
        <Grid container spacing={2}>
          {Array.from({ length: skeletonCount }).map((_, idx) => (
            <HotelCardSkeleton key={`hotel-skel-${idx}`} idx={idx} />
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default HotelsResultsContainerSkeleton;
